import React from 'react';
// Components
import ManageMerch from 'components/common/ManageMerch';

const ManageContentCreatorMerch: React.FC = () => {
  return <ManageMerch />;
};

export default ManageContentCreatorMerch;
